
import {
  Save as SaveIcon
} from "@mui/icons-material";
import { Button, TextField, Typography,Paper, Box, Avatar } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import {ProfileContainer} from "../style/ProfileStyles";
import { MeData } from "../services/MeServices"; // Import the MeData service

const Profile = () => {
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    role: "",
    userId: "",
    phone: "",
    coursesEnrolled: 5,
    hoursSpent: 24,
    certificates: 3,
  });

  const [isEditing, setIsEditing] = useState(false);
  const [editedData, setEditedData] = useState({ ...userData });

  const RoleType = useSelector((state) => state.role);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await MeData();
        if (response.success && response.user) {
          const { userName, userEmailId, userPhone, roleType, userId } = response.user;
          setUserData((prev) => ({
            ...prev,
            name: userName || prev.name,
            email: userEmailId || prev.email,
            phone: userPhone || prev.phone,
            role: roleType || prev.role,
            userId: userId || prev.userId,
          }));
          setEditedData((prev) => ({
            ...prev,
            name: userName || prev.name,
            email: userEmailId || prev.email,
            phone: userPhone || prev.phone,
            role: roleType || prev.role,
            userId: userId || prev.userId,
          }));
        }
      } catch (error) {
        console.error("Error fetching user data from MeData", error);
      }
    };

    fetchUserData();
  }, []);

  const handleEditToggle = () => {
    if (isEditing) {
      setEditedData({ ...userData });
    }
    setIsEditing(!isEditing);
  };

  const handleSaveChanges = () => {
    setUserData({ ...editedData });
    localStorage.setItem("userData", JSON.stringify(editedData));
    setIsEditing(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedData({
      ...editedData,
      [name]: value,
    });
  };

  return (
    <ProfileContainer>
      <Paper className="profile_info_paper" elevation={3}>
        <Box className="section_header">
          <Typography variant="h5" component="h2" className="middle">
            Profile Information
          </Typography>
        </Box>

        <Box className="profile_info">
          <Avatar className= "profile_avatar">
            {userData.name
              .split(" ")
              .map((n) => n[0])
              .join("")}
          </Avatar>
          <Typography variant="h6" gutterBottom>
            {userData.name}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {userData.role}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            ID: {userData.userId}
          </Typography>
        </Box>

        <Box className= "text_field_container">
          <Box className="text_field_row">
            <TextField
              fullWidth
              label="Full Name"
              name="name"
              value={isEditing ? editedData.name : userData.name}
              onChange={handleInputChange}
              disabled={!isEditing}
              variant="outlined"
              size="small"
            />
          </Box>

          <Box className="text_field_row">
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={isEditing ? editedData.email : userData.email}
              onChange={handleInputChange}
              disabled={!isEditing}
              variant="outlined"
              size="small"
            />
          </Box>

          <Box className="text_field_row">
            <TextField
              fullWidth
              label="Phone"
              name="phone"
              value={isEditing ? editedData.phone : userData.phone}
              onChange={handleInputChange}
              disabled={!isEditing}
              variant="outlined"
              size="small"
            />
          </Box>
        </Box>

        {isEditing && (
          <Box className="save_button_container">
            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={handleSaveChanges}
            >
              Save Changes
            </Button>
          </Box>
        )}
      </Paper>
    </ProfileContainer>
  );
};

export default Profile;